import * as components from './components'

export default [
  {
    path: '/selfReportedCourse/list',
    component: components.SelfReportedCourseList,
    name: 'selfReportedCourseList',
    props: true
  },
  {
    path: '/transferArticulation/list',
    component: components.TransferArticulationMappingList,
    name: 'transferArticulationMappingList',
    props: true
  },
  {
    path: '/transferArticulation/upload',
    component: components.TransferArticulationMappingUpload,
    name: 'transferArticulationMappingUpload',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/transfer/routes.js